export default __webpack_public_path__ + "static/media/redo.73bbf405.svg";